import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Product',
  icon: 'mdi-cube-outline',
  path: '/reports/product/',
  children: [
    {
      path: '/reports/product/productMixDrillDown',
      name: 'Product Mix',
      meta: { id: 'mc-productMix', permission: 'pmix' },
      component: () => import('./ProductMix.vue'),
      ...addPermissionsToRoute(['pmix']),
    },
    {
      path: '/reports/product/productMixTrend',
      name: 'Product Mix Trend',
      meta: { id: 'mc-productMixTrend', permission: 'pmix' },
      component: () => import('./ProductMixTrend.vue'),
      ...addPermissionsToRoute(['pmix']),
    },
  ],
};

export default routes;
